import Vue from 'vue'
import Router from 'vue-router'
import main from '@/frame/main'
import login from '@/frame/login'
import Customerlogin from '@/frame/Customerlogin'
import ShopifyLogin from '@/frame/ShopifyLogin'
import CustomerResetPwd from '@/frame/CustomerResetPwd'
import Index from '@/frame/Index'
import Register from '@/frame/Register'
Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    name: 'Login',
    component: login,
    children: []
  },
  {
    path: '/Register',
    name: 'Register',
    component: Register,
    children: []
  },
  {
    path: '/ShopifyLogin',
    name: 'ShopifyLogin',
    component: ShopifyLogin,
    children: []
  },
  


  {
    path: '/Customerlogin',
    name: 'Customerlogin',
    component: Customerlogin,
    children: []
  },

  {
    path: '/CustomerResetPwd',
    name: 'CustomerResetPwd',
    component: CustomerResetPwd,
    children: []
  },

  {
    path: '/Main',
    name: 'Main',
    component: main,
    children: [{
      path: 'index',
      components: {}
    },]
  },

  {
    path: '/Root',
    component: Index,
  },
  {
    path: '/New/:ID',
    component: () =>
      import('@/frame/Sys/New'),
  },
  {
    path: '/UserManage',
    component: () =>
      import('@/frame/Sys/UserManage'),
  },
  {
    path: '/DepartmentPage',
    component: () =>
      import('@/frame/Sys/DepartmentPage'),
  },
  {
    path: '/RolePage',
    component: () =>
      import('@/frame/Sys/RolePage'),
  },
  {
    path: '/RightPage',
    component: () =>
      import('@/frame/Sys/RightPage'),
  },

  {
    path: '/RegionPage',
    component: () =>
      import('@/frame/Sys/RegionPage'),
  },
  {
    path: '/ChannelInfoPage',
    component: () =>
      import('@/frame/Channel/ChannelInfoPage'),
  },
  {
    path: '/BaseChannel',
    component: () =>
      import('@/frame/Channel/BaseChannel'),
  },
  {
    path: '/AddChannelInfoPage/:ChannelInfoID',
    component: () =>
      import('@/frame/Channel/AddChannelInfoPage'),
  },
  {
    path: '/SeeChannelInfoPage/:ChannelInfoID',
    component: () =>
      import('@/frame/Channel/SeeChannelInfoPage'),
  },
  {
    path: '/AddSubChannelInfoPage/:ChannelInfoID/:ID',
    component: () =>
      import('@/frame/Channel/AddSubChannelInfoPage'),
  },
  {
    path: '/AddChannelAreaInfo/:ChannelInfoID/:SubChannelInfoID/:ID',
    component: () =>
      import('@/frame/Channel/AddChannelAreaInfo'),
  },
  {
    path: '/PublicData',
    component: () =>
      import('@/frame/Sys/PublicData'),
  },

  {
    path: '/Earnings',
    component: () =>
      import('@/frame/Popularize/Earnings'),
  },
  {
    path: '/FAQ',
    component: () =>
      import('@/frame/Popularize/FAQ'),
  },
  {
    path: '/Referrals',
    component: () =>
      import('@/frame/Popularize/Referrals'),
  },

  {
    path: '/PayoutRequests',
    component: () =>
      import('@/frame/Popularize/PayoutRequests'),
  },
  {
    path: '/Organization',
    component: () =>
      import('@/frame/Organization/Organization'),
  },
  {
    path: '/ChannelType',
    component: () =>
      import('@/frame/Channel/ChannelType'),
  },
  {
    path: '/ChannelMeal',
    component: () =>
      import('@/frame/Channel/ChannelMeal'),
  },
  {
    path: '/NextCompany',
    component: () =>
      import('@/frame/Channel/NextCompany'),
  },
  {
    path: '/ChannelSurcharge',
    component: () =>
      import('@/frame/Channel/ChannelSurcharge'),
  },
  {
    path: '/ChannelApiType',
    component: () =>
      import('@/frame/Channel/ChannelApiType'),
  },
  {
    path: '/AddChannelApiType/:ID',
    component: () =>
      import('@/frame/Channel/AddChannelApiType'),
  },
  {
    path: '/SendAddress',
    component: () =>
      import('@/frame/order/SendAddress'),
  },
  {
    path: '/Warehouse',
    component: () =>
      import('@/frame/Warehouse/Warehouse'),
  },
  {
    path: '/WareHousesLocation',
    component: () =>
      import('@/frame/Warehouse/WareHousesLocation'),
  },
  {
    path: '/WareHousesLocationReplace',
    component: () =>
      import('@/frame/Warehouse/WareHousesLocationReplace'),
  },
  {
    path: '/WareHousesPath',
    component: () =>
      import('@/frame/Warehouse/WareHousesPath'),
  },
  {
    path: '/AddWareHousesPath/:ID',
    component: () =>
      import('@/frame/Warehouse/AddWareHousesPath'),
  },
  {
    path: '/OpentorFeeDiscount',
    component: () =>
      import('@/frame/Warehouse/OpentorFeeDiscount'),
  },
  {
    path: '/OrderOpentorFee',
    component: () =>
      import('@/frame/Warehouse/OrderOpentorFee'),
  },
  {
    path: '/LabelSetting',
    component: () =>
      import('@/frame/LabelSetting'),
  },
  {
    path: '/ChannelItemSetup',
    component: () =>
      import('@/frame/Channel/ChannelItemSetup'),
  },
  {
    path: '/UpFee',
    component: () =>
      import('@/frame/Warehouse/UpFee'),
  },
  {
    path: '/UpFeesDiscount',
    component: () =>
      import('@/frame/Warehouse/UpFeesDiscount'),
  },
  {
    path: '/PalletFee',
    component: () =>
      import('@/frame/Warehouse/PalletFee'),
  },
  {
    path: '/LabelShow',
    component: () =>
      import('@/frame/LabelShow'),
  },
  {
    path: '/Customer',
    component: () =>
      import('@/frame/Customer/Customer'),
  },

  {
    path: '/AddCustomer/:ID',
    component: () =>
      import('@/frame/Customer/AddCustomer'),
  },

  {
    path: '/ColorMark',
    component: () =>
      import('@/frame/Sys/ColorMark'),
  },


  {
    path: '/AddService',
    component: () =>
      import('@/frame/Sys/AddService'),
  },


  {
    path: '/CompanyInfo',
    component: () =>
      import('@/frame/Sys/CompanyInfo'),
  },
  {
    path: '/EmailConfig',
    component: () =>
      import('@/frame/Sys/EmailConfig'),
  },


  {
    path: '/MyCustomerWhouse',
    component: () =>
      import('@/frame/Warehouse/MyCustomerWhouse'),
  },
  {
    path: '/CustomerWhouse',
    component: () =>
      import('@/frame/Warehouse/CustomerWhouse'),
  },
  {
    path: '/ProductType',
    component: () =>
      import('@/frame/Warehouse/ProductType'),
  },
  {
    path: '/MyProductType',
    component: () =>
      import('@/frame/Warehouse/MyProductType'),
  },

  {
    path: '/Product',
    component: () =>
      import('@/frame/Warehouse/Product'),
  },
  {
    path: '/ProductMall',
    component: () =>
      import('@/frame/Warehouse/ProductMall'),
  },
  {
    path: '/AddProduct/:ID',
    component: () =>
      import('@/frame/Warehouse/AddProduct'),
  },
  //添加商城产品
  {
    path: '/ShopAddProduct/:ID',
    component: () =>
      import('@/frame/Warehouse/ShopAddProduct'),
  },
  {
    path: '/AddASN_Purchases/:ID',
    component: () =>
      import('@/frame/Warehouse/AddASN_Purchases'),
  },
  {
    path: '/AddMallPurchase/:ID',
    component: () =>
      import('@/frame/Warehouse/AddMallPurchase'),
  },
  {
    path: '/AddMallPurchaseEdit/:ID',
    component: () =>
      import('@/frame/Warehouse/AddMallPurchaseEdit'),
  },



  {
    path: '/MyProduct',
    component: () =>
      import('@/frame/Warehouse/MyProduct'),
  },
  {
    path: '/MyAddProduct/:ID',
    component: () =>
      import('@/frame/Warehouse/MyAddProduct'),
  },
  {
    path: '/ApplyQuotation/:ID',
    component: () =>
      import('@/frame/Warehouse/ApplyQuotation'),
  },

  {
    path: '/Supplier',
    component: () =>
      import('@/frame/Warehouse/Supplier'),
  },


  {
    path: '/MySupplier',
    component: () =>
      import('@/frame/Warehouse/MySupplier'),
  },


  {
    path: '/SkuMapping',
    component: () =>
      import('@/frame/Warehouse/SkuMapping'),
  },
  {
    path: '/AddSkuMapping/:ID',
    component: () =>
      import('@/frame/Warehouse/AddSkuMapping'),
  },



  {
    path: '/MySkuMapping',
    component: () =>
      import('@/frame/Warehouse/MySkuMapping'),
  },
  {
    path: '/MyAddSkuMapping/:ID/:StoreNeme',
    component: () =>
      import('@/frame/Warehouse/MyAddSkuMapping'),
  },

  {
    path: '/ASN_Purchases',
    component: () =>
      import('@/frame/Warehouse/ASN_Purchases'),
  },
  {
    path: '/ASN_PurchasesMall',
    component: () =>
      import('@/frame/Warehouse/ASN_PurchasesMall'),
  },
  {
    path: '/AddASN_Purchases/:ID',
    component: () =>
      import('@/frame/Warehouse/AddASN_Purchases'),
  },
  {
    path: '/PurchaseAccount',
    component: () =>
      import('@/frame/Warehouse/PurchaseAccount'),
  },

  {
    path: '/MyASN_Purchases',
    component: () =>
      import('@/frame/Warehouse/MyASN_Purchases'),
  },
  {
    path: '/MyAddASN_Purchases/:ID',
    component: () =>
      import('@/frame/Warehouse/MyAddASN_Purchases'),
  },

  {
    path: '/InventoryCustomer',
    component: () =>
      import('@/frame/Warehouse/InventoryCustomer'),
  },

  {
    path: '/InventoryTotal',
    component: () =>
      import('@/frame/Warehouse/InventoryTotal'),
  },

  {
    path: '/Inventory',
    component: () =>
      import('@/frame/Warehouse/Inventory'),
  },


  {
    path: '/MyInventoryCustomer',
    component: () =>
      import('@/frame/Warehouse/MyInventoryCustomer'),
  },

  {
    path: '/ASN_Receives',
    component: () =>
      import('@/frame/Warehouse/ASN_Receives'),
  },
  {
    path: '/ASN_ReceivesScan/:ID',
    component: () =>
      import('@/frame/Warehouse/AddASN_Receives'),
  },
  {
    path: '/AddReceiveBox/:ID',
    component: () =>
      import('@/frame/Warehouse/AddReceiveBox'),
  },
  {
    path: '/ParcelSigning',
    component: () =>
      import('@/frame/Warehouse/ParcelSigning'),
  },

  {
    path: '/AddASN_Receives/:ID',
    component: () =>
      import('@/frame/Warehouse/AddASN_Receives'),
  },

  {
    path: '/BuckleCharge',
    component: () =>
      import('@/frame/Logistics/BuckleCharge'),
  },

  {
    path: '/FastScanning/:Post',
    component: () =>
      import('@/frame/Logistics/FastScanning'),
  },

  {
    path: '/Scanandcollectgoods/:Post',
    component: () =>
      import('@/frame/Logistics/Scanandcollectgoods'),
  },

  {
    path: '/PackInfo',
    component: () =>
      import('@/frame/Logistics/PackInfo'),
  },

  {
    path: '/BankInfo',
    component: () =>
      import('@/frame/Finance/BankInfo'),
  },
  //客户本月账单统计
  {
    path: '/CustomerDelivery',
    component: () =>
      import('@/frame/Finance/CustomerDelivery'),
  },

  {
    path: '/ExchangeRate',
    component: () =>
      import('@/frame/Finance/ExchangeRate'),
  },

  {
    path: '/AccountInCome',
    component: () =>
      import('@/frame/Finance/AccountInCome'),
  },

  {
    path: '/Invoice',
    component: () =>
      import('@/frame/Finance/Invoice'),
  },
  
  {
    path: '/WareHouseOperateFee',
    component: () =>
      import('@/frame/Finance/WareHouseOperateFee'),
  },

  {
    path: '/AddInvoice/:ID',
    component: () =>
      import('@/frame/Finance/AddInvoice'),
  },

  {
    path: '/PaidDetail',
    component: () =>
      import('@/frame/Finance/PaidDetail'),
  },


  {
    path: '/ReceiverAddress',
    component: () =>
      import('@/frame/Order/ReceiverAddress')
  },
  {
    path: '/ShopCustomer',
    component: () =>
      import('@/frame/Order/ShopCustomer')
  },
  //店铺分析
  {
    path: '/StoreAnalysis',
    component: () =>
      import('@/frame/Order/StoreAnalysis')
  },

  {
    path: '/Order',
    component: () =>
      import('@/frame/Order/Order')
  },

  {
    path: '/AddOrder/:ID/:s',
    component: () =>
      import('@/frame/Order/AddOrder')
  },
  {
    path: '/OrderAfter/:ID/:Types/:AfterStatus',
    component: () => 
    import('@/frame/Order/OrderAfter')
  },
  
  {
    path: '/MyInvoice',
    component: () =>
      import('@/frame/Finance/MyInvoice')
  },

  {
    path: '/MyAddInvoice/:ID',
    component: () =>
      import('@/frame/Finance/MyAddInvoice')
  },

  {
    path: '/MyPaidDetail',
    component: () =>
      import('@/frame/Finance/MyPaidDetail')
  },

  {
    path: '/PrintProduct/:PrintNumber/:StateName',
    component: () =>
      import('@/frame/Warehouse/PrintProduct')
  },
  {
    path: '/PrintProduct2/:PrintNumber/:SKU',
    component: () =>
      import('@/frame/Warehouse/PrintProduct2')
  },
  {
    path: '/PickUpBatch',
    component: () =>
      import('@/frame/Warehouse/PickUpBatch')
  },

  {
    path: '/PickUpBatchByPrint/:ID',
    component: () =>
      import('@/frame/Warehouse/PickUpBatchByPrint')
  },

  {
    path: '/PickUpBatchByPrintLocation',
    component: () =>
      import('@/frame/Warehouse/PickUpBatchByPrintLocation')
  },

  {
    path: '/MultiItemOrder',
    component: () =>
      import('@/frame/Warehouse/MultiItemOrder')
  },

  {
    path: '/SingleOrderReinsurance',
    component: () =>
      import('@/frame/Warehouse/SingleOrderReinsurance')
  },

  {
    path: '/OrderForProductCheck',
    component: () =>
      import('@/frame/Warehouse/OrderForProductCheck')
  },
  {
    path: '/OrderToMoveIn',
    component: () =>
      import('@/frame/Warehouse/OrderToMoveIn')
  },
  {
    path: '/OrderToMoveInPrint',
    component: () =>
      import('@/frame/Warehouse/OrderToMoveInPrint')
  },


  {
    path: '/PrintOrderLabel/:oids/:Type',
    component: () =>
      import('@/frame/Order/PrintOrderLabel')
  },
  {
    path: '/OrderList',
    component: () =>
      import('@/frame/Order/OrderList')
  }
  ,
  {
    path: '/OrderSubmit',
    component: () =>
      import('@/frame/Order/OrderSubmit')
  },
  {
    path: '/OrderReturns',
    component: () =>
      import('@/frame/Order/OrderReturns')
  },
  {
    path: '/DeliverBacth',
    component: () =>
      import('@/frame/Logistics/DeliverBacth')
  },

  {
    path: '/AddDeliverBacth/:ID',
    component: () =>
      import('@/frame/Logistics/AddDeliverBacth')
  },

  {
    path: '/DeliverBacthByPrint/:ID',
    component: () =>
      import('@/frame/Logistics/DeliverBacthByPrint')
  },

  {
    path: '/PrintLabel',
    component: () =>
      import('@/frame/Logistics/PrintLabel')
  },


  {
    path: '/FreightInquiries',
    component: () =>
      import('@/frame/Order/FreightInquiries')
  },


  {
    path: '/CancelReceipt',
    component: () =>
      import('@/frame/Logistics/CancelReceipt')
  },


  {
    path: '/CancelOrder',
    component: () =>
      import('@/frame/Logistics/CancelOrder')
  },



  {
    path: '/QuestionType',
    component: () =>
      import('@/frame/Order/QuestionType')
  },


  {
    path: '/Question',
    component: () =>
      import('@/frame/Order/Question')
  },



  {
    path: '/AddQuestion/:ID',
    component: () =>
      import('@/frame/Order/AddQuestion')
  },



  {
    path: '/MyQuestion',
    component: () =>
      import('@/frame/Order/MyQuestion')
  },

  {
    path: '/HelpGuide',
    component: () =>
      import('@/frame/Order/HelpGuide')
  },


  {
    path: '/MyAddQuestion/:ID',
    component: () =>
      import('@/frame/Order/MyAddQuestion')
  },



  {
    path: '/RegistrationDiscount',
    component: () =>
      import('@/frame/Finance/RegistrationDiscount')
  },

  {
    path: '/InventoryInAndOut',
    component: () =>
      import('@/frame/Warehouse/InventoryInAndOut')
  },


  {
    path: '/OrderInfo/:ID',
    component: () =>
      import('@/frame/Order/OrderInfo')
  },
 



  {
    path: '/ASN_PurchasesPrint/:ID',
    component: () =>
      import('@/frame/Warehouse/ASN_PurchasesPrint')
  },

  {
    path: '/UpdatePassword',
    component: () =>
      import('@/frame/Sys/UpdatePassword')
  },

  {
    path: '/PersonalInformation', component: () => import('@/frame/Sys/PersonalInformation')
  },

  {
    path: '/PersonalEmail',
    component: () =>
      import('@/frame/Sys/PersonalEmail')
  },

  {
    path: '/MyEmailMessage',
    component: () =>
      import('@/frame/Sys/MyEmailMessage'),
  },
  {
    path: '/UploadAfterShip',
    component: () =>
      import('@/frame/Order/UploadAfterShip')
  },



  {
    path: '/CharacterParent',
    component: () =>
      import('@/frame/Sys/CharacterParent')
  },


  {
    path: '/Sys_NewsType',
    component: () =>
      import('@/frame/Sys/Sys_NewsType')
  },



  {
    path: '/Sys_New',
    component: () =>
      import('@/frame/Sys/Sys_New')
  },


  {
    path: '/AddSys_New/:ID',
    component: () =>
      import('@/frame/Sys/AddSys_New')
  },


  {
    path: '/MyShopProduct/:IsOrderNotSkuMapping',
    component: () =>
      import('@/frame/Warehouse/MyShopProduct')
  },

  // {
  //   path: '/MyAddShopProduct/:ID',
  //   component:()=> import('@/frame/Warehouse/MyAddShopProduct')
  // },

  {
    path: '/MyAddShopProduct/:ID',
    component: () =>
      import('@/frame/Warehouse/MyAddShopProduct'),
  },
  {
    path: '/MyAddShopProduct2/:ID',
    component: () =>
      import('@/frame/Warehouse/MyAddShopProduct2'),
  },


  {
    path: '/AddPopularize',
    component: () =>
      import('@/frame/Popularize/AddPopularize'),
  },


  {
    path: '/GeneralizeRate',
    component: () =>
      import('@/frame/Popularize/GeneralizeRate'),
  },


  {
    path: '/Commission',
    component: () =>
      import('@/frame/Popularize/Commission'),
  },

  {
    path: '/MyPopularize',
    component: () =>
      import('@/frame/Popularize/MyPopularize'),
  },


  {
    path: '/MyGeneralize',
    component: () =>
      import('@/frame/Popularize/MyGeneralize'),
  },

  {
    path: '/MyAddGeneralize/:ID',
    component: () =>
      import('@/frame/Popularize/MyAddGeneralize'),
  },

  {
    path: '/Generalize',
    component: () =>
      import('@/frame/Popularize/Generalize'),
  },

  {
    path: '/AddGeneralize/:ID',
    component: () =>
      import('@/frame/Popularize/AddGeneralize'),
  },



  {
    path: '/PurchaseRequest',
    component: () =>
      import('@/frame/Order/PurchaseRequest'),
  },

  {
    path: '/AddPurchaseRequest/:ID',
    component: () =>
      import('@/frame/Order/AddPurchaseRequest'),
  },



  {
    path: '/MyPurchaseRequest',
    component: () =>
      import('@/frame/Order/MyPurchaseRequest'),
  },

  {
    path: '/MyAddPurchaseRequest/:ID',
    component: () =>
      import('@/frame/Order/MyAddPurchaseRequest'),
  },



  {
    path: '/EmailMessage',
    component: () =>
      import('@/frame/Sys/EmailMessage'),
  },



  {
    path: '/AddEmailMessage/:ID',
    component: () =>
      import('@/frame/Sys/AddEmailMessage'),
  },

  {
    path: '/MyAddEmailMessage/:ID',
    component: () =>
      import('@/frame/Sys/MyAddEmailMessage'),
  },


  {
    path: '/InventoryCheck',
    component: () =>
      import('@/frame/Warehouse/InventoryCheck'),
  },



  {
    path: '/AddInventoryCheck/:ID',
    component: () =>
      import('@/frame/Warehouse/AddInventoryCheck'),
  },
  {
    path: '/AfterSale',
    component: () =>
      import('@/frame/AfterSale/AfterSale'),
  },
  {
    path: '/MyShoppingMall',
    component: () =>
      import('@/frame/Warehouse/MyShoppingMall'),
  },

  



  {
    path: '/desktop_main',
    component: () =>
      import('@/frame/desktop_main'),
    name: 'desktop_main',
    children: [{
      path: 'UserManage',
      component: () =>
        import('@/frame/Sys/UserManage'),
    },



    ]
  },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js